import PropTypes from 'prop-types';
import styles from './style.module.scss';
import { Row, Col, Modal, Input } from 'antd';
import { Button } from 'components';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'hooks/useNavigate';
import { useLocation } from 'react-router-dom';
import UIHelper from 'helpers/UIHelper';
import { useState } from 'react';

const SendMessageModal = ({ onClickSend, loading }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');
  const history = useNavigate();
  const { pathname } = useLocation();

  const handleCancel = () => {
    history(UIHelper.getListRoute(pathname));
  };

  const handleOk = () => {
    onClickSend(message);
  };

  return (
    <Modal visible={true} onCancel={handleCancel} footer={false}>
      <div className={styles.modalContent}>
        <div className={styles.infoIcon}>
          <InfoCircleOutlined />
        </div>
        <div className={styles.title}>{t('INVIA MESSAGGIO')}</div>
        <Row gutter={[14, 14]} align='middle' justify={'center'}>
          <Col span={24}>
            <Input
              onChange={(e) => setMessage(e.target.value)}
              value={message}
              placeholder={t('Messaggio')}
            />
          </Col>
          <Col>
            <Button loading={loading} onClick={handleOk} width={'170px'} big>
              {t('Invia')}
            </Button>
          </Col>
          <Col>
            <Button
              onClick={handleCancel}
              width={'170px'}
              type={'primary-white'}
              big
            >
              {t('Annulla')}
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

SendMessageModal.propTypes = {
  onClickSend: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default SendMessageModal;
